export default __webpack_public_path__ + "static/media/YUAN300.00c4e692.pdf";